import { useSelector } from 'react-redux'
import { titleSelector } from 'redux/selectors'

const useMenuTitle = ({ name }) => {
  return useSelector((state) => titleSelector(state, name))
}

export default useMenuTitle
